/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --nve-sys-interaction-background: var(--nve-sys-interaction-background-300);
  --nve-sys-interaction-field-background: var(--nve-sys-interaction-background-300);
  --nve-sys-layer-popover-arrow-padding: 6px;
  --nve-sys-layer-popover-arrow-offset: 2px;
  --nve-sys-layer-popover-offset: 2px;
  --arrow-transform: translate(0, -2px) rotate(-45deg);
  --border: var(--nve-ref-border-width-sm) solid var(--nve-ref-border-color-muted);
  --border-radius: var(--nve-ref-border-radius-md);
  --background: var(--nve-sys-layer-overlay-background);
  --color: var(--nve-sys-layer-overlay-color);
  --font-size: var(--nve-ref-font-size-100);
  --font-weight: var(--nve-ref-font-weight-regular);
  --padding: var(--nve-ref-size-400);
  --box-shadow: var(--nve-ref-shadow-400);
  --width: fit-content;
  --min-width: fit-content;
  --gap: var(--nve-ref-space-sm);
  --_divider-padding: var(--padding);
}

[internal-host] {
  padding: var(--padding);
  border-radius: var(--border-radius);
  border: var(--border);
  background: var(--background);
  color: var(--color);
  gap: var(--nve-ref-space-sm);
  width: var(--width);
  min-width: var(--min-width);
  outline: 0;
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  box-shadow: var(--box-shadow);
}

[internal-host]::backdrop {
  background: transparent;
}

nve-icon-button {
  position: absolute;
  top: var(--nve-ref-size-200);
  right: var(--nve-ref-size-200);
  z-index: 99;
}

.arrow {
  width: var(--nve-ref-size-300);
  height: var(--nve-ref-size-300);
  background: var(--background);
  transform: var(--arrow-transform);
  border-radius: var(--nve-ref-size-50);
  position: absolute;
}

:host([position*='top']) {
  --arrow-transform: translate(0, -2px) rotate(-45deg);
}

:host([position*='right']) {
  --arrow-transform: translate(2px, 0) rotate(45deg);
}

:host([position*='bottom']) {
  --arrow-transform: translate(0, 2px) rotate(45deg);
}

:host([position*='left']) {
  --arrow-transform: translate(-2px, 0) rotate(45deg);
}

::slotted(nve-menu) {
  --width: 100%;
}

::slotted(nve-divider) {
  margin: 0 calc(-1 * var(--_divider-padding));
}

#content {
  margin: calc(var(--padding) * -0.5) 0;
}
